export default function Writing() {
  return (
    <div className="p-6 max-w-3xl mx-auto">
        <h2 className="mb-4">
        I have a passion for authentic human expression and creativity. I love writing and believe firmly that it
        is an unique and powerful tool for self-expression, communication, and connection. These essays are an opportunity
        for me to improve my writing skills while simultaneously sharing my own thoughts, interests, and research materials 
        with the posibility of engaging others in topics that I am interested in exploring.
        </h2>

        <h2 className="text-2xl font-semibold mt-6 mb-2">Essays</h2>
      
    </div>
  );
}